define.alias("shared/utils/hash-code", "settings/utils/platform-check");